var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"res"},[_c('div',{staticClass:"title"}),_c('div',{staticClass:"content"},[_c('res-success')],1),_c('div',{staticClass:"bottom"},[_c('countdown-btn',{attrs:{"countdown":5,"copy":"回到首页"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }